import React from 'react';

import { TopTags } from './TopTags.js';

interface NoResultsProps {
  section: string;
}

export const NoResults: React.FC<NoResultsProps> = ({ section }) => {
  return (
    <div className="no-results">
      <p className="no-results-message">{`Vi fikk ingen treff dessverre. Prøv igjen eller sjekk noen av filtrene under 👇`}</p>
      <TopTags section={section} />
    </div>
  );
};
